import React from 'react'
import { Card, Button, Box, Typography, Grid } from '@mui/material'
import RFG from "../../libs/inputs/RFG"
import { useDispatch, useSelector } from "react-redux"
import { useForm } from 'react-hook-form'
import { FORGOT } from "../../services/actions"
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs"
import { useNavigate } from 'react-router-dom'

export default function ResetPassword() {
  let dispatch = useDispatch()
  const navigate = useNavigate()
  let user = useSelector((state) => state?.loginState.auth)
  const { handleSubmit, control, watch } = useForm({
    defaultValues: {},
    mode: "all"
  })
  const [param, setParam] = React.useState({})
  const [matchError, setMatchError] = React.useState("")

  const cardRef = React.useRef(null);

  React.useEffect(() => {
    const hash = window.location.hash;
    const queryString = hash.split("?")[1];
    const params = new URLSearchParams(queryString);
    const emailFromUrl = params.get("email");
    const id = params.get("becon");
    if (emailFromUrl) {
      setParam({ email: emailFromUrl, id: id });
    }
  }, [])

  return (
    <>
      <Box
        sx={{
          width: 1, height: '100vh',
          background: '#a4abb6',
        }}>

        <Grid container display={'flex'} alignItems={'center'} justifyContent={'center'}>
          <Grid size={{ xs: 12, sm: 12, md: 6 }}>
            <Box display={'flex'} alignItems={'center'} justifyContent={'center'}
              sx={{
                width: 1, height: '100vh',
                background: '#a4abb6',
                p: '5%',
              }}>

              <Card sx={{
                minWidth: 210,
                background: 'linear-gradient(30deg, #e3e5e6, rgb(247, 235, 210)) no-repeat',
                width: 1, mx: '10%'
              }}>
                <Box display={'flex'} alignItems={'center'} justifyContent={'center'}
                  sx={{
                    width: 1, height: '80vh', p: '20%'
                  }}>
                  <Box>
                    <Box sx={{ textAlign: 'center', }}>
                      <Typography fontSize={16} fontWeight={800} color="#717171">Reset Password</Typography>
                      <Typography fontSize={13} sx={{ my: 2 }} color="#717171">Welcome to widelapse monitoring system</Typography>
                    </Box>
                    <form autoComplete="false" onSubmit={handleSubmit((data) => {
                      data.id = param.id
                      data.email = param.email
                      console.log("FORM", data)
                      if(data.password){
                        data.reset_url = null
                      }
                      else{
                        data.reset_url = window.location.href.replace(/\/?$/, '/') + "reset-password"
                      }                      
                      if (data.password !== data.confirm) {
                        setMatchError("Password and confirm password mismatch")
                      } else {
                        dispatch({ type: `${FORGOT}_POST`, payload: data });
                      }
                    })}>
                      <Typography> {param.email}</Typography>
                      {/* <RFG labelStyle={{ color: "#717171" }} name="email" label="Email" control={control} rules={{ required: true }} className="mb-2">
                        <input autoComplete="false" style={{ borderRadius: 12, color: "#717171" }} />
                      </RFG> */}
                      <RFG labelStyle={{ color: "#717171" }} name="password" label="New Password" control={control} rules={{ required: true }} className="mb-2">
                        <input autoComplete="false" style={{ borderRadius: 12, color: "#717171" }} />
                      </RFG>
                      <RFG labelStyle={{ color: "#717171" }} name="confirm" label="Confirm Password" control={control} rules={{ required: true }} className="mb-2">
                        <input autoComplete="false" style={{ borderRadius: 12, color: "#717171" }} />
                      </RFG>


                      <Button sx={{ width: 1, mt: 3, background: '#ffd85f', borderRadius: 2 }} type="submit">Submit</Button>
                    </form>
                    <Typography sx={{ mt: 2, fontSize: 12, textAlign: 'center', color: "#717171" }}
                      onClick={() => { navigate('/') }}>Back to login</Typography>

                    <Box fontSize={12} className="error">{user?.message}</Box>
                    <Box fontSize={12} className="error">{matchError}</Box>

                    <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                      <Typography sx={{ mt: 2, fontSize: 12, textAlign: 'right', color: "#717171" }}>Powered by widelapse</Typography>
                      <Typography sx={{ mt: 2, fontSize: 12, textAlign: 'right', color: "#717171" }}>Terms & conditions</Typography>
                    </Box>
                  </Box>
                </Box>
              </Card>
            </Box>
          </Grid>
          {/* <Grid size={{ xs: 12, sm: 12, md: 7 }} sx={{ p: '1%', display: { xs: 'none', sm: 'none', md: 'block' } }}>
              <Box display={'flex'} alignItems={'center'} justifyContent={'center'}
                sx={{
                  width: 1, height: '80vh', overflow: 'hidden', borderRadius: 3
                }}>
                <img height={'100%'} src={"https://images.pexels.com/photos/2341830/pexels-photo-2341830.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"} />
              </Box>
            </Grid> */}
        </Grid>
      </Box>
    </>
  )
}

